import { ArrowDownward, ArrowUpward, Delete as DeleteIcon } from '@mui/icons-material';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import { BLOCK_TYPE_LABELS } from './newContentManagementEditorConstants';

interface ContentBlockToolbarProps {
  index: number;
  total: number;
  blockType: string;
  onMove: (index: number, direction: 'up' | 'down') => void;
  onRemove: (index: number) => void;
  /** An extra control specific to this block type (e.g. "Add Footnote"), shown before the
   * move/delete icons. */
  action?: React.ReactNode;
}

/** The grey header strip on a content block: its type label + move/delete controls. */
export default function ContentBlockToolbar({
  index,
  total,
  blockType,
  onMove,
  onRemove,
  action,
}: ContentBlockToolbarProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2,
        py: 0.75,
        bgcolor: Palette.default.background,
        borderBottom: `1px solid ${Palette.default.border}`,
      }}
    >
      <Typography variant="caption" fontWeight={600} color="text.secondary">
        {BLOCK_TYPE_LABELS[blockType] ?? blockType}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        {action}
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <Tooltip title="Move up">
            <span>
              <IconButton size="small" onClick={() => onMove(index, 'up')} disabled={index === 0}>
                <ArrowUpward fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Move down">
            <span>
              <IconButton
                size="small"
                onClick={() => onMove(index, 'down')}
                disabled={index === total - 1}
              >
                <ArrowDownward fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Delete block">
            <IconButton
              size="small"
              onClick={() => onRemove(index)}
              sx={{ color: Palette.warning.buttonBg }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </Box>
  );
}
